export default "__VITE_ASSET__BcMM23ll__"